import React from 'react';
import { useLocation } from 'react-router';

import { OmaLummeApp } from '../../omaLummeContext';

import InfoBlock from './InfoBlock';
import NewsCollection from './NewsCollection';
import Loading from '../Common/Loading';
import SubMenu from '../Common/SubMenu';
import Box from '../Common/Box';

// Actions.
import { fetchNews } from '../../actions';
import CurrentNews from './CurrentNews';
import { useTranslation } from 'react-i18next';

const NewsContainer: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = OmaLummeApp.useDispatch();

  const { users, news } = OmaLummeApp.useState();

  const [prevEndPoint, setPrevEndPoint] = React.useState('');
  const location = useLocation();
  const mainLocation = location.pathname.split('/')[1];

  React.useEffect(() => {
    // Create an scoped async function in the hook
    async function fetchAvailableNews(): Promise<void> {
      const news = await fetchNews(users.activeUser.endpoint, mainLocation === 'news' ? 999 : 5);

      const sortedNews = news.sort((a, b) => {
        const aDate = new Date(a.publishDate);
        const bDate = new Date(b.publishDate);
        if (aDate < bDate) return 1;
        if (aDate > bDate) return -1;

        return 0;
      });

      dispatch(['changeNews', sortedNews]);
    }
    if (users.activeUser.endpoint !== prevEndPoint) {
      setPrevEndPoint(users.activeUser.endpoint);
      // Execute the created function directly
      if (!(users.activeUser.endpoint === 'anon' && mainLocation === 'news') && news.length <= 6) {
        fetchAvailableNews();
      }
    }
  }, [users.activeUser.endpoint, prevEndPoint]);

  let toDisplay: React.JSX.Element = <div></div>;

  if (mainLocation === 'news' && news.length < 7) {
    return <Loading />;
  }

  if (users.activeUser.endpoint !== 'anon' && news) {
    switch (mainLocation) {
      case '': {
        toDisplay = <CurrentNews />;
        break;
      }
      case 'news':
        toDisplay = (
          <>
            <Box>
              <SubMenu />
              <NewsCollection />
            </Box>
            <Box>
              <h2>{t('customerService:news.currentNewsTitle')}</h2>
              <CurrentNews />
            </Box>
          </>
        );
        break;
      default:
        toDisplay = <InfoBlock />;
    }
  }

  return <>{toDisplay}</>;
};

export default NewsContainer;
